module.exports = __webpack_public_path__ + "img/house-heart.6d0775fb.svg";